/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_ListInputs */

const en_import_list = /** @type {(inputs: Import_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imports · ${i?.count}`)
};

const de_import_list = /** @type {(inputs: Import_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importe · ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Imports · {count}" |
*
* @param {Import_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_list = /** @type {((inputs: Import_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_list(inputs)
	return en_import_list(inputs)
});